export const CLI_KIT_VERSION = '3.46.0'
